import { useField } from "formik";
import { TextInput, TextInputProps } from "react-native-paper";

const NON_NUMBERS_REGEX = /[^0-9]/g;

type BaseProps = Omit<TextInputProps, "theme" | "value" | "onChangeText">;

// theme prop should be optional, but for some reason is triggering linter.
// https://github.com/callstack/react-native-paper/blob/main/src/components/TextInput/TextInput.tsx#L135
type Props = BaseProps & {
  value: number;
  onChangeValue: (value: number) => void;
};

// takes integer numbers only
export default function NumberInput({ value, onChangeValue, ...props }: Props) {
  const onChangeText = (text: string) => {
    // Remove thousands separators (commas) in groups of three digits
    const withoutThousandsSeparator = text.replace(
      /(\d),(?=(\d{3})+(?!\d))/g,
      "$1"
    );

    // Replace decimal separator (comma) with a period
    const withDecimalSeparator = withoutThousandsSeparator.replace(
      /,(\d{1,2})$/g,
      ".$1"
    );

    const sanitized = Number(
      withDecimalSeparator.replace(NON_NUMBERS_REGEX, "")
    ); // remove non-digits

    onChangeValue(sanitized);
  };

  return (
    <TextInput
      mode="outlined"
      value={value ? `${value}` : ""}
      placeholder="0"
      onChangeText={onChangeText}
      keyboardType="number-pad"
      returnKeyType="done"
      returnKeyLabel="next" // only works on android https://github.com/facebook/react-native/issues/31794
      {...props}
    />
  );
}

type FormikProps = BaseProps & { fieldName: string };
export const FormikNumberInput = ({ fieldName, ...props }: FormikProps) => {
  const [field, , helpers] = useField<number>(fieldName);

  return (
    <NumberInput
      value={field.value}
      onChangeValue={helpers.setValue}
      onBlur={field.onBlur(fieldName)}
      {...props}
    />
  );
};
